import { useSnackbar } from 'notistack';
import { useNavigate, useParams } from 'react-router-dom';
import FormSkeleton from '../../../../components/Skeletons/FormSkeleton';
import HttpService from '../../../../services/HttpService';
import {useState, useEffect} from 'react';
import RoleForm from '../_features/RoleForm';
import { IEditRole } from '../_features/type';
import AsyncBackdropSubmit from '../../../../components/AsyncBackdropSubmit';

const EditInternalRole = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSubmitLoading, setIsSubmitLoading] = useState<boolean>(false);

  const getData = async () => {
    try {      
      const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/authorization/groups/${id}/roles`);
      setData(response.data);
      setIsLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleDelete = async () => {
    try {  
      await HttpService.getAxiosClient().delete(`${process.env.REACT_APP_BACKEND_URL}/authorization/group/${data.id}`);
      enqueueSnackbar('Ο Ρόλος διαγράφτηκε επιτυχώς', { variant: 'success' });
      navigate('/admin/roles/dashboard');
    } catch (error) {
      enqueueSnackbar('Η Διαγραφή απέτυχε, παρακαλώ προσπαθήστε ξανά ή επικοινωνήστε με τον διαχειριστή σας!', { variant: 'error' });
      console.error(error);
    }
  };

  const onSubmit = async (values: IEditRole) => {
    setIsSubmitLoading(true);
    try {      
      const response = await HttpService.getAxiosClient().put(`${process.env.REACT_APP_BACKEND_URL}/authorization/groups/${id}/roles`, values);
      if (response.status === 200){
        enqueueSnackbar(`Επιτυχής Επεξεργασία του Ρόλου: ${response.data.name}`, { variant: 'success' });
      } 
      setIsSubmitLoading(false);
      navigate('/admin/roles/dashboard');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Η Επεξεργασία απέτυχε, παρακαλώ προσπαθήστε ξανά ή επικοινωνήστε με τον διαχειριστή σας!', { variant: 'error' });
      setIsSubmitLoading(false);
    }
  };

  return (
    <>
      <AsyncBackdropSubmit isLoading={isSubmitLoading}>
        Παρακαλώ περιμένετε μέχρι να ολοκληρωθεί η διαδικασία...
      </AsyncBackdropSubmit>
      {isLoading
        ? <FormSkeleton lines={4} />
        : <RoleForm 
          edit
          internal={true} 
          title={data?.name} 
          initialValues={data}
          permissionCategories={data.roles}
          onSubmit={onSubmit}
          handleDelete={handleDelete}
        />}
    </>
  );
};

export default EditInternalRole;